module.exports = __webpack_public_path__ + "img/Essilor_RGB_Blue.be79f325.jpg";